<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/Leave_Tomorrow_Behind2#Contents-A">Epigraph</a></p>
<p class="body para-style-override-3"><span class="Italic">Dance, dance, dance little lady</span></p>
<p class="body para-style-override-3"><span class="Italic">So obsessed with second best</span></p>
<p class="body para-style-override-3"><span class="Italic">No rest you’ll ever find</span></p>
<p class="body para-style-override-3"><span class="Italic">Time and tide and trouble</span></p>
<p class="body para-style-override-3"><span class="Italic">Never, never wait</span></p>
<p class="body para-style-override-3"><span class="Italic">Let the cauldron bubble</span></p>
<p class="body para-style-override-3"><span class="Italic">Justify your fate</span></p>
<p class="body para-style-override-3"><span class="Italic">Dance, dance, dance little lady</span></p>
<p class="body para-style-override-3"><span class="Italic">Dance, dance, dance little lady</span></p>
<p class="body para-style-override-3"><span class="Italic">Leave tomorrow behind.</span></p>
<p class="body para-style-override-4">—Noel Coward</p>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Leave_Tomorrow_Behind-5.vue?307fd116